// react imports
import React, { useEffect, useState } from "react";
// style imports
import s from "./FormProviders.module.css";
//servicios
import providersService from "../../../../api/providers/providersService";
import gamesService from "../../../../api/games/GamesService";
import placesService from "../../../../api/places";
import accountingService from "../../../../api/accounting/accountingServices";
//assets
import { setProviders } from "../../../../store/slices/gammaSlice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
//Material
import {
  Grid,
  MenuItem,
  TextField,
  FormControl,
  Select,
  Button,
  Box,
  Switch,
  Autocomplete,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CircularProgress from "@mui/material/CircularProgress";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import useTranslationException from "../../../../helpers/exceptions";
import { useNotificationContext } from "../../../Notifications/CustomNotifications";

// =========================== | FORM PROVIDERS | ==============================

const FormProviders = ({ items, setItems, editable, setEditable }) => {
  const notification = useNotificationContext();
  const { allGameOffersActive } = useSelector((state) => state.gamma);

  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const showExpetion = useTranslationException(t, i18n);
  const { textColor } = useSelector((state) => state.local);
  const { activeOrganization } = useSelector((state) => state.gamma);

  const mailCondition = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

  const [taxConditions, setTaxConditions] = useState([]);
  const [taxConditionStatus, setTaxConditionStatus] = useState({
    loading: false,
    error: false,
  });
  const [keyPushed, setKeyPushed] = useState("");
  const [cuit, setCuit] = useState("");
  const [form, setForm] = useState({
    cuit: editable.status ? editable.item.cuit : "",
    businessName: editable.status ? editable.item.businessName : "",
    fiscalCondition: editable.status ? editable.item.fiscalCondition : "none",
    address: editable.status ? editable.item.address : "",
    numberAddress: editable.status ? editable.item.numberAddress : null,
    phone: editable.status ? editable.item.phone : "",
    enabled: editable.status ? editable.item.enabled : true,
    typeSupplier: editable.status ? editable.item?.typeSupplier : "none",
    email: editable.status ? editable.item?.email : "",
    contact: editable.status ? editable.item?.contact : "",
    addressSupplier: editable.status ? editable.item.address : "",
    province: editable.status ? editable.item?.province : "",
    location: editable.status ? editable.item?.location : "",
    postalCode: editable.status ? editable.item?.postalCode : "",
  });

  const [formGames, setFormGames] = useState([]);
  const [createGames, setCreateGames] = useState(false);

  const [loading, setLoading] = useState(false);

  const [loadingLocation, setLoadingLocation] = useState(false);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [location, setLocation] = useState({
    province: null,
    inputProvince: "",
    city: null,
    inputCity: "",
  });

  const [games, setGames] = useState([]);

  let type = ["Transportista", "Proveedor", "Transportista/Proveedor", "Otro"];

  const [errors, setErrors] = useState({
    cuit: false,
    mail: false,
  });

  //TODO: Aplicar la expresion regular desde el config
  const formatFiscalId = (fiscalId) => {
    let formattedCuit = fiscalId
      .toString()
      .replace(/(\d{2})(\d{8})(\d{1})/, "$1-$2-$3");
    return formattedCuit;
  };

  const unformatFiscalId = (fiscalId) => {
    let unformattedCuit = fiscalId.toString().replace(/-/g, "");
    return parseInt(unformattedCuit);
  };

  useEffect(() => {
    if (editable.status) {
      setForm({ ...form, cuit: editable.item.cuit });
      setCuit(editable.item.cuit);
    } else {
      setForm({ ...form, cuit: unformatFiscalId(cuit) || "" });
    }
  }, [cuit]);

  useEffect(() => {
    if (editable.status) {
      providersService
        .getGamesProvider(editable.item.id, dispatch)
        .then((res) => {
          if (res !== "NOT_FOUND") {
            setCreateGames(false);
            setFormGames([...res?.gamesIds]);
          } else {
            setCreateGames(true);
          }
        });
    }
    setGames(allGameOffersActive);
    // getGameOffers(activeOrganization?.id, 1, dispatch)
    //     .then(res => setGames(res.content));
  }, [allGameOffersActive]);

  useEffect(() => {
    setTaxConditionStatus((prev) => ({ ...prev, loading: true }));
    accountingService
      .getTaxConditions()
      .then((res) => {
        setTaxConditions(res.content || []);
      })
      .then(() =>
        setTaxConditionStatus((prev) => ({ error: false, loading: false })),
      )
      .catch(() =>
        setTaxConditionStatus((prev) => ({ error: true, loading: false })),
      );

    if (provinces.length === 0) {
      setLoadingLocation(true);
      //TODO: Cambiar por un id de pais dinamico/seleccionable
      placesService.getProvinces(1).then((res) => {
        res.content.sort((a, b) => {
          const nameA = a.name.toUpperCase();
          const nameB = b.name.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        setProvinces(res.content);
        if (editable.status) {
          let province = res.content.find(
            (item) => item.name === editable.item?.province,
          );
          if (province?.id) {
            setLocation((prev) => ({
              ...prev,
              province: province,
            }));
            placesService.getCities(province.id).then((response) => {
              response.content.sort((a, b) => {
                const nameA = a.name.toUpperCase();
                const nameB = b.name.toUpperCase();
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
                return 0;
              });
              setCities(response.content);
              let city = response.content.find(
                (item) => item.name === editable.item?.location,
              );
              setLocation((prev) => ({
                ...prev,
                city: city,
              }));
              setLoadingLocation(false);
            });
          }
        } else {
          setLoadingLocation(false);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (location?.province !== null) {
      setForm((prev) => ({ ...prev, province: location?.province?.name }));
      placesService.getCities(location?.province?.id).then((res) => {
        res.content.sort((a, b) => {
          const nameA = a.name.toUpperCase();
          const nameB = b.name.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        setCities(res.content);
      });
    } else {
      setForm((prev) => ({ ...prev, province: "" }));
    }
    setLocation((prev) => ({
      ...prev,
      city: null,
      inputCity: "",
    }));
  }, [location.province]);

  useEffect(() => {
    if (location?.city !== null) {
      setForm((prev) => ({ ...prev, location: location?.city?.name }));
    } else {
      setForm((prev) => ({ ...prev, location: location?.city?.name }));
    }
  }, [location.city]);

  const handleCheck = (value, item) => {
    if (!value) {
      setFormGames([...formGames, item.modality.game.id]);
    } else {
      let filter = formGames.filter((i) => i !== item.modality.game.id);
      setFormGames([...filter]);
    }
  };

  const handleSubmit = () => {
    if (
      mailCondition.test(form.email) &&
      unformatFiscalId(cuit).toString().length === 11
    ) {
      setLoading(true);
      if (editable.status) {
        Swal.fire({
          title: `${t("providerEdit")} ${form.businessName}`,
          text: t("providerEditConfirm"),
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: t("confirm"),
          cancelButtonText: t("cancel"),
        }).then((result) => {
          if (result.isConfirmed) {
            providersService
              .updateProvider({ ...form, id: editable.item.id }, dispatch)
              .then((response) => {
                if (formGames.length) {
                  if (createGames) {
                    providersService
                      .addGamesProvider(formGames, response.id, dispatch)
                      .then(() => {
                        Swal.fire(
                          t("providerSuccessEdit"),
                          t("providerSuccessEditText"),
                          "success",
                        ).then(() => {
                          let newItems = [...items];
                          newItems[editable.index] = response;
                          setItems([...newItems]);
                        });
                      });
                  } else {
                    providersService
                      .updateGamesProvider(formGames, response.id, dispatch)
                      .then(() => {
                        Swal.fire(
                          t("providerSuccessEdit"),
                          t("providerSuccessEditText"),
                          "success",
                        )
                          .then(() => {
                            providersService
                              .getProviders(1, 10, dispatch)
                              .then((res) => {
                                setItems(res.content);
                              })
                              .then(() => {
                                providersService
                                  .getActiveProviders()
                                  .then((response) =>
                                    dispatch(setProviders(response.content)),
                                  )
                                  .catch((error) => {
                                    notification.error(
                                      "Error ep",
                                      error.message,
                                    );
                                  });
                              });
                          })
                          .then(() =>
                            setEditable({
                              item: null,
                              index: null,
                              status: false,
                            }),
                          )
                          .then(() => setLoading(false))
                          .then(() => navigate("../proveedores"));
                      });
                  }
                } else {
                  providersService
                    .deleteGamesProvider(response.id, dispatch)
                    .then(() => {
                      Swal.fire({
                        title: t("providerSuccessEdit"),
                        text: t("providerSuccessEditText"),
                        icon: "success",
                      })
                        .then(() => {
                          providersService
                            .getProviders(1, 10, dispatch)
                            .then((res) => {
                              setItems(res.content);
                            })
                            .then(() => {
                              providersService
                                .getActiveProviders()
                                .then((response) =>
                                  dispatch(setProviders(response.content)),
                                )
                                .catch((error) => {
                                  notification.error("Error ep", error.message);
                                });
                            });
                        })
                        .then(() =>
                          setEditable({
                            item: null,
                            index: null,
                            status: false,
                          }),
                        )
                        .then(() => setLoading(false))
                        .then(() => navigate("../proveedores"));
                    });
                }
              });
          } else {
            setLoading(false);
          }
        });
      } else {
        setLoading(true);
        Swal.fire({
          title: t("providerCreateTitle"),
          text: t("providerCreateText"),
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: t("confirm"),
          cancelButtonText: t("cancel"),
        }).then((result) => {
          if (result.isConfirmed) {
            providersService
              .newProvider(form, dispatch)
              .then((response) => {
                if (formGames.length) {
                  providersService
                    .addGamesProvider(formGames, response.id, dispatch)
                    .then((res) => {
                      Swal.fire({
                        title: t("providerSuccessCreate"),
                        text: t("providerSuccessCreateText"),
                        icon: "success",
                      })
                        .then(() => {
                          providersService
                            .getProviders(1, 10, dispatch)
                            .then((res) => {
                              setItems(res.content);
                            });
                        })
                        .then(() => {
                          providersService
                            .getActiveProviders()
                            .then((response) => {
                              dispatch(setProviders(response.content));
                            })
                            .catch((error) => {
                              notification("Error ep", error.message);
                            });
                        })
                        .then(() => setLoading(false))
                        .then(() => navigate("../proveedores"));
                    });
                }
              })
              .catch((e) => {
                showExpetion.showErrorModalForServiceException(
                  e,
                  { icon: "warning" },
                  t("anErrorOccurred,TryAgain"),
                  t("sorryErrorOcurred"),
                );
                setLoading(false);
              });
          } else {
            setLoading(false);
          }
        });
      }
    } else {
      Swal.fire(t("providerFormFields"), t("verifyFormFields"), "warning");
    }
  };

  //TODO: esto no adapta a otros tipos de expresiones regulares esta atado al CUIT argetino.
  const handleSetCuit = (e) => {
    let numberPressed =
      !isNaN(e.target.value[e.target.value.length - 1]) ||
      keyPushed === "Backspace" ||
      e.target.value.length === 0;
    if (numberPressed) {
      if (i18n.language === "es") {
        e.target.value.toString().split("-").join("").length === 11
          ? setErrors({ ...errors, cuit: false })
          : setErrors({ ...errors, cuit: true });
        if (keyPushed !== "Backspace") {
          if (cuit?.length === 2) {
            setCuit((cuit) => `${cuit}-${e.target.value.slice(2)}`);
          } else if (cuit?.length === 11) {
            setCuit((cuit) => `${cuit}-${e.target.value.slice(11)}`);
          } else {
            setCuit(e.target.value);
          }
        } else {
          setCuit(e.target.value);
        }
      } else {
        setErrors({ ...errors, cuit: false });
        setCuit(e.target.value);
      }
    }
  };

  useEffect(() => {
    gamesService.getAllActivesGameOffers(dispatch);
  }, [activeOrganization?.id, dispatch]);

  return (
    <Grid container className={s.container}>
      <Grid item xs={10} className={s.titleContainer}>
        <ArrowBackIcon
          sx={{
            color: "primary.main",
            fontSize: "2rem",
            opacity: loading ? 0 : 1,
          }}
          onClick={() => {
            setEditable({
              item: null,
              index: null,
              status: false,
            });
            navigate(-1);
          }}
          className={s.arrow}
        />
        <h4>
          {editable.status ? t("providerEdit") : t("providerCreateTitle")}
        </h4>
      </Grid>

      <Grid item container xs={10} className={s.form}>
        <Grid item lg={5} md={10} xs={12} sx={{ ml: 9 }}>
          <p style={{ fontSize: "1rem" }}>{`${t("state")}:  ${
            form.enabled ? t("active") : t("inactive")
          }`}</p>
          <Switch
            color="primary"
            checked={form.enabled}
            onChange={() => setForm({ ...form, enabled: !form.enabled })}
          />
        </Grid>
        <Grid item lg={5} md={10} xs={12} className={s.inputItem}></Grid>
        <Grid item lg={5} md={10} xs={12} className={s.inputItem}>
          <p className={s.titleinput}>{t("businessName")}*</p>
          <TextField
            sx={{ width: "80%" }}
            value={form.businessName}
            variant="outlined"
            onChange={(e) => setForm({ ...form, businessName: e.target.value })}
          />
        </Grid>
        <Grid item lg={5} md={10} xs={12} container className={s.inputItem}>
          <p className={s.titleinput}>CUIT*</p>
          <Grid item xs={10} className={s.cuitForm}>
            {!editable.status ? (
              <TextField
                sx={{ width: "100%" }}
                disabled={editable.status}
                error={errors.cuit}
                value={cuit}
                helperText={errors.cuit ? `⚠ ${t("cuitError")}` : ""}
                inputProps={i18n.language === "es" ? { maxLength: 13 } : {}}
                placeholder={i18n.language === "es" ? "XX-XXXXXXXX-X" : "CUIT"}
                onClick={() => {
                  document.addEventListener(
                    "keydown",
                    (e) => {
                      var keyValue = e.key;
                      setKeyPushed(keyValue);
                    },
                    false,
                  );
                }}
                onChange={handleSetCuit}
              />
            ) : (
              <h2>{formatFiscalId(editable?.item?.cuit)}</h2>
            )}
          </Grid>
        </Grid>
        <Grid item container lg={5} md={10} xs={12} className={s.inputItem}>
          <p className={s.titleinput}>{t("taxCondition")}*</p>
          {taxConditionStatus?.loading ? (
            <Grid item xs={12}>
              <CircularProgress size="2rem" />
            </Grid>
          ) : taxConditionStatus.error ? (
            <Grid item xs={10} sx={{ textAlign: "center" }}>
              {t("noTaxConditionAvailable")}
            </Grid>
          ) : (
            <FormControl sx={{ width: "80%" }}>
              <Select
                value={form.fiscalCondition}
                onChange={(e) =>
                  setForm({ ...form, fiscalCondition: e.target.value })
                }
              >
                <MenuItem value="none">{t("select")}</MenuItem>
                {taxConditions?.map((item, i) => (
                  <MenuItem key={i} value={item.name}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Grid>

        <Grid item lg={5} md={10} xs={12} className={s.inputItem}>
          <p className={s.titleinput}>{t("type")}</p>
          <FormControl sx={{ width: "80%" }}>
            <Select
              value={form.typeSupplier}
              onChange={(e) =>
                setForm({ ...form, typeSupplier: e.target.value })
              }
            >
              <MenuItem value="none">{t("select")}</MenuItem>
              {type.map((item, i) => (
                <MenuItem key={i} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item lg={5} md={10} xs={12} className={s.inputItem}>
          <p className={s.titleinput}>{t("mail")}*</p>
          <TextField
            sx={{ width: "80%" }}
            error={errors.mail}
            value={form.email}
            helperText={
              errors.mail
                ? form.email
                  ? "⚠ Email debe ser válido!"
                  : t("obligatoryField")
                : ""
            }
            variant="outlined"
            onChange={(e) => {
              mailCondition.test(e.target.value)
                ? setErrors({ ...errors, mail: false })
                : setErrors({ ...errors, mail: true });
              setForm({ ...form, email: e.target.value });
            }}
          />
        </Grid>

        <Grid item lg={5} md={10} xs={12} className={s.inputItem}>
          <p className={s.titleinput}>{t("phone")}*</p>
          <TextField
            sx={{ width: "80%" }}
            value={form.phone}
            variant="outlined"
            type="number"
            onChange={(e) =>
              setForm({
                ...form,
                phone: e.target.value ? parseInt(e.target.value, 10) : "",
              })
            }
          />
        </Grid>

        <Grid item container lg={9} md={8} xs={10} className={s.inputItem}>
          <p className={s.titleAddress}>
            {t("location")}
            {loadingLocation ? (
              <CircularProgress size={"1.5rem"} sx={{ ml: 1 }} />
            ) : null}
          </p>
          <Grid item xs={12} className={s.address}>
            <Autocomplete
              value={location.province}
              onChange={(event, newValue) => {
                setLocation((prev) => ({
                  ...prev,
                  province: newValue,
                }));
              }}
              inputValue={location.inputProvice}
              onInputChange={(event, newInputValue) => {
                setLocation((prev) => ({
                  ...prev,
                  inputProvince: newInputValue,
                }));
              }}
              options={provinces}
              getOptionLabel={(option) => option.name}
              sx={{ width: "32%" }}
              renderInput={(params) => (
                <TextField {...params} label={t("province")} />
              )}
            />
            <Autocomplete
              value={location.city}
              onChange={(event, newValue) => {
                setLocation((prev) => ({
                  ...prev,
                  city: newValue,
                }));
              }}
              inputValue={location.inputCity}
              onInputChange={(event, newInputValue) => {
                setLocation((prev) => ({
                  ...prev,
                  inputCity: newInputValue,
                }));
              }}
              //TODO: Verificar caso de Ciudad Autonoma de BSAS
              disabled={!location.province || location.province?.id === 4880}
              options={cities || []}
              getOptionLabel={(option) => option.name}
              sx={{ width: "32%" }}
              renderInput={(params) => (
                <TextField {...params} label={t("city")} autoComplete="off" />
              )}
            />
            <TextField
              sx={{ width: "32%" }}
              placeholder="C.P"
              variant="outlined"
              value={form.postalCode}
              onChange={(e) => setForm({ ...form, postalCode: e.target.value })}
            />
          </Grid>
        </Grid>

        <Grid item lg={5} md={10} xs={12} className={s.inputItem}>
          <p className={s.titleinput}>{t("address")}*</p>
          <TextField
            sx={{ width: "80%" }}
            value={form.address}
            variant="outlined"
            onChange={(e) => setForm({ ...form, address: e.target.value })}
          />
        </Grid>
        <Grid item lg={5} md={10} xs={12} className={s.inputItem}>
          <p className={s.titleinput}>{t("number")}</p>
          <TextField
            sx={{ width: "80%" }}
            type="number"
            value={form.numberAddress}
            variant="outlined"
            InputProps={{
              inputProps: { min: 0 },
            }}
            onChange={(e) => {
              if (!isNaN(e.target.value) && Number(e.target.value) >= 0) {
                setForm({
                  ...form,
                  numberAddress: Number(e.target.value) || null,
                });
              }
            }}
            onKeyPress={(e) => {
              if (e?.key === "-" || e?.key === "+") {
                e.preventDefault();
              }
            }}
          />
        </Grid>

        <Grid item lg={5} md={10} xs={12} className={s.inputItem}>
          <p className={s.titleinput}>{t("contact")}</p>
          <TextField
            sx={{ width: "80%" }}
            value={form.contact}
            variant="outlined"
            onChange={(e) => setForm({ ...form, contact: e.target.value })}
          />
        </Grid>

        <Grid item lg={5} md={10} xs={12} className={s.inputItem}></Grid>

        <Grid item container lg={9} md={10} xs={12}>
          <p style={{ fontSize: "1rem" }}>{`${t("games")}: ( ${
            formGames?.length
          } ${t("selected")} )`}</p>
          <Grid item container xs={12} className={s.checkboxes}>
            {!games?.length ? (
              <CircularProgress />
            ) : (
              games?.map((item, i) => (
                <React.Fragment key={i}>
                  <Grid
                    key={i}
                    item
                    xs={12}
                    className={s.check}
                    onClick={() =>
                      handleCheck(
                        formGames.includes(item.modality.game.id),
                        item,
                      )
                    }
                  >
                    <Box
                      className={s.borderB}
                      sx={{
                        width: formGames.includes(item.modality.game.id)
                          ? "95%"
                          : "0",
                        backgroundColor: "primary.main",
                      }}
                    ></Box>
                    <Box className={s.dataGame}>
                      <Box className={s.imgcontainer}>
                        <CheckCircleRoundedIcon
                          className={s.checkImg}
                          sx={{
                            color: "primary.main",
                            opacity: formGames.includes(item.modality.game.id)
                              ? 1
                              : 0,
                          }}
                        />
                        {item.modality.game.image ? (
                          <img
                            src={item.modality.game.image}
                            alt={item.modality.game.name}
                            style={{
                              opacity: formGames.includes(item.modality.game.id)
                                ? 0.1
                                : 1,
                            }}
                          />
                        ) : (
                          <RadioButtonUncheckedIcon
                            className={s.circle}
                            sx={{
                              color: "primary.main",
                              opacity: formGames.includes(item.modality.game.id)
                                ? 0
                                : 1,
                            }}
                          />
                        )}
                      </Box>
                      <p>{item.modality.game.name}</p>
                    </Box>
                    <Box
                      className={s.borderB}
                      sx={{
                        width: formGames.includes(item.modality.game.id)
                          ? "95%"
                          : "0",
                        backgroundColor: "primary.main",
                      }}
                    ></Box>
                  </Grid>
                </React.Fragment>
              ))
            )}
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} md={10} className={s.sendButton}>
        <Button
          size="small"
          variant="contained"
          className={s.btn}
          sx={{ backgroundColor: "primary.main", color: textColor }}
          onClick={handleSubmit}
          disabled={
            !(
              (form.businessName.length &&
                cuit &&
                form.fiscalCondition !== "none" &&
                form.address.length &&
                form.email &&
                form.phone &&
                !errors.mail &&
                !errors.cuit) ||
              (editable.status &&
                form.businessName.length &&
                form.fiscalCondition !== "none" &&
                form.address.length &&
                form.phone &&
                form.email &&
                !errors.mail &&
                !errors.cuit)
            ) || loading
          }
        >
          {loading ? (
            <CircularProgress color="secondary" />
          ) : editable.status ? (
            `${t("saveChanges")}`
          ) : (
            `${t("add")} ${t("providers")}`
          )}
        </Button>
      </Grid>
    </Grid>
  );
};

export default FormProviders;
